/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayBrightnessV2Slider_ConfigFragment = { __typename: 'ConfigurationModel', id: string, brightnessV2?: { __typename: 'ConfigBrightnessV2State', value: number, autoBrightness?: boolean | null } | null };

export type ConfigUpdateBrightnessV2MutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateBrightnessV2Input;
}>;


export type ConfigUpdateBrightnessV2Mutation = { __typename: 'Mutation', configurationUpdateBrightnessV2: { __typename: 'ConfigurationModel', id: string, brightnessV2?: { __typename: 'ConfigBrightnessV2State', value: number, autoBrightness?: boolean | null } | null } };

export const ConfigDisplayBrightnessV2Slider_ConfigFragmentDoc = gql`
    fragment ConfigDisplayBrightnessV2Slider_config on ConfigurationModel {
  id
  brightnessV2 {
    value
    autoBrightness
  }
}
    `;
export const ConfigUpdateBrightnessV2Document = gql`
    mutation ConfigUpdateBrightnessV2($input: ConfigurationUpdateBrightnessV2Input!) {
  configurationUpdateBrightnessV2(input: $input) {
    ...ConfigDisplayBrightnessV2Slider_config
  }
}
    ${ConfigDisplayBrightnessV2Slider_ConfigFragmentDoc}`;
export type ConfigUpdateBrightnessV2MutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateBrightnessV2Mutation, ConfigUpdateBrightnessV2MutationVariables>;

/**
 * __useConfigUpdateBrightnessV2Mutation__
 *
 * To run a mutation, you first call `useConfigUpdateBrightnessV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateBrightnessV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateBrightnessV2Mutation, { data, loading, error }] = useConfigUpdateBrightnessV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateBrightnessV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateBrightnessV2Mutation, ConfigUpdateBrightnessV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateBrightnessV2Mutation, ConfigUpdateBrightnessV2MutationVariables>(ConfigUpdateBrightnessV2Document, options);
      }
export type ConfigUpdateBrightnessV2MutationHookResult = ReturnType<typeof useConfigUpdateBrightnessV2Mutation>;
export type ConfigUpdateBrightnessV2MutationResult = ApolloReactCommon.MutationResult<ConfigUpdateBrightnessV2Mutation>;
export type ConfigUpdateBrightnessV2MutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateBrightnessV2Mutation, ConfigUpdateBrightnessV2MutationVariables>;